import {
  AudioWave01Icon,
  GlobalSearchIcon,
  Image03Icon,
  ModernTvIcon,
  ShoppingCart01Icon,
  UserGroup03Icon,
} from '@hugeicons-pro/core-stroke-rounded'
import type { IconSvgElement } from '@hugeicons/react'

export const CHANNEL_ICON: Record<string, IconSvgElement> = {
  search: GlobalSearchIcon,
  social: UserGroup03Icon,
  tv: ModernTvIcon,
  programmatic: Image03Icon,
  audio: AudioWave01Icon,
  retail: ShoppingCart01Icon,
}

export const CHANNEL_GRADIENT: Record<string, string> = {
  search: 'bg-[image:var(--tile-search)]',
  social: 'bg-[image:var(--tile-social)]',
  tv: 'bg-[image:var(--tile-tv)]',
  programmatic: 'bg-[image:var(--tile-programmatic)]',
  audio: 'bg-[image:var(--tile-audio)]',
  retail: 'bg-[image:var(--tile-retail)]',
}

export function channelIconFor(key: string): IconSvgElement {
  return CHANNEL_ICON[key] ?? GlobalSearchIcon
}

export function channelGradientFor(key: string): string {
  return CHANNEL_GRADIENT[key] ?? CHANNEL_GRADIENT.search
}
